import { gql, useMutation } from '@apollo/client';
import { GET_WAGES_AND_SALARY } from './get-all-wages-and-salary.hook';

export const DELETE_WAGES_AND_SALARY_BY_ID = gql`
  mutation deleteWagesAndSalaryById($id: String!) {
    deleteWagesAndSalaryById(id: $id) {
      _id
    }
  }
`;

export const useDeleteWagesAndSalaryById = () => {
  const [deleteWagesAndSalaryById] = useMutation(DELETE_WAGES_AND_SALARY_BY_ID, {
    refetchQueries: [GET_WAGES_AND_SALARY],
  });

  return deleteWagesAndSalaryById;
};
